import { ShoppingBag, BellRing } from "lucide-react";
import { Reveal, SectionHead } from "@/components/Reveal";
import { CONTACT } from "@/lib/site";
import { scrollToSection } from "@/lib/scroll";

export default function Boutique() {
  const requestAccessory = () => {
    window.dispatchEvent(
      new CustomEvent("prefill-devis", {
        detail: { message: "BOUTIQUE — je cherche un accessoire : (verre trempé, coque, chargeur, câble USB-C, support, batterie externe…)" },
      })
    );
    scrollToSection("#devis");
  };

  const notify = () => {
    window.dispatchEvent(
      new CustomEvent("prefill-devis", {
        detail: { message: "BOUTIQUE — je souhaite être prévenu de l'ouverture de la boutique MAXREVIX (accessoires & protections)." },
      })
    );
    scrollToSection("#devis");
  };

  return (
    <section id="boutique" className="relative overflow-hidden py-24 lg:py-32">
      <div className="pointer-events-none absolute left-1/2 top-1/2 h-[420px] w-[760px] -translate-x-1/2 -translate-y-1/2 rounded-full bg-neon/10 blur-[130px]" aria-hidden="true" />
      <div className="relative mx-auto w-full max-w-7xl px-5 lg:px-8">
        <SectionHead
          tag="Boutique"
          title={<>Accessoires & protections <span className="text-neon">très bientôt</span></>}
          sub="Verres trempés, coques, chargeurs, câbles USB-C, supports et batteries externes : une sélection MAXREVIX arrive en boutique."
        />

        <Reveal delay={0.1}>
          <div className="relative mt-10 overflow-hidden rounded-3xl border border-neon/25 bg-gradient-to-b from-neon/10 via-ink to-ink px-6 py-14 text-center lg:py-20">
            <div className="pointer-events-none absolute left-1/2 top-1/2 h-[300px] w-[560px] -translate-x-1/2 -translate-y-1/2 rounded-full bg-neon/15 blur-[100px]" aria-hidden="true" />
            <p
              data-testid="boutique-soon"
              className="text-outline-cyan relative select-none font-display text-[clamp(4.5rem,17vw,15rem)] font-black leading-none tracking-tight"
              aria-label="Boutique bientôt disponible"
            >
              SOON
            </p>
            <p className="relative mx-auto mt-6 max-w-md text-sm leading-relaxed text-slate-400 sm:text-base">
              La boutique MAXREVIX ouvre bientôt : protections d'écran, coques, chargeurs,
              câbles et accessoires choisis pour durer.
            </p>
            <div className="relative mt-8 flex flex-col items-stretch justify-center gap-3 sm:flex-row sm:items-center sm:justify-center">
              <button
                data-testid="boutique-request-btn"
                onClick={requestAccessory}
                className="flex items-center justify-center gap-2 rounded-full bg-neon px-7 py-4 text-sm font-extrabold uppercase tracking-wider text-night chip-glow transition-transform duration-200 hover:scale-[1.04]"
              >
                <ShoppingBag size={16} />
                Demander mon accessoire
              </button>
              <button
                data-testid="boutique-notify-btn"
                onClick={notify}
                className="flex items-center justify-center gap-2 rounded-full border border-line px-7 py-4 text-sm font-bold uppercase tracking-wider text-white transition-colors duration-200 hover:border-neon hover:text-neon"
              >
                <BellRing size={16} />
                Être prévenu de l'ouverture
              </button>
            </div>
            <p className="relative mx-auto mt-7 flex max-w-xl items-start justify-center gap-2 text-[11px] leading-relaxed text-slate-500 sm:text-xs">
              <ShoppingBag size={13} className="mt-0.5 shrink-0 text-neon" />
              <span>
                En attendant l'ouverture, <strong className="font-semibold text-white">passez par la demande de devis</strong> : dites-nous ce que
                vous cherchez — verre trempé, coque, chargeur, câble… — nous vous disons ce qui est disponible et nous vous le réservons, ou passez
                à l'atelier et nous vous conseillons sur place. Pressé ?{" "}
                <a data-testid="boutique-note-phone" href={CONTACT.phoneHref} className="font-semibold text-neon hover:underline">
                  {CONTACT.phoneDisplay}
                </a>
              </span>
            </p>
          </div>
        </Reveal>
      </div>
    </section>
  );
}